import React, { useEffect, useState } from "react";

const LS_KEY = "adult_gate_18plus_v1";

type Props = {
    redirectUrl?: string; // default: https://google.com
    minAge?: number;      // default: 18
};

export default function AdultGate({ redirectUrl = "https://google.com", minAge = 18 }: Props) {
    const [needsGate, setNeedsGate] = useState(false);

    useEffect(() => {
        // If localStorage isn't available (blocked/disabled), immediately gate.
        try {
            const ok = localStorage.getItem(LS_KEY) === "true";
            setNeedsGate(!ok);
        } catch {
            setNeedsGate(true);
        }
    }, []);

    const redirectAway = () => {
        // Hard redirect (prevents back-button returning to gated content in many cases)
        window.location.replace(redirectUrl);
    };

    const accept = () => {
        try {
            localStorage.setItem(LS_KEY, "true");
            setNeedsGate(false);
        } catch {
            // Can't store => treat as not allowed to proceed per your requirement
            redirectAway();
        }
    };

    if (!needsGate) return null;

    return (
        <div style={styles.backdrop} role="dialog" aria-modal="true" aria-label="Adults only warning">
            <div style={styles.card}>
                <h1 style={styles.title}>Adults Only ({minAge}+)</h1>

                <p style={styles.p}>
                    This website contains <b>explicit erotic fiction</b> intended for adults.
                    By continuing, you confirm that you are at least <b>{minAge}</b> years old and
                    that viewing adult sexual content is legal where you live.
                </p>

                <p style={styles.p}>
                    If you are under {minAge}, uncomfortable with erotic content, or cannot legally view it,
                    you must leave now.
                </p>

                <div style={styles.buttonRow}>
                    <button style={{ ...styles.button, ...styles.leave }} onClick={redirectAway}>
                        I am under {minAge} / Leave
                    </button>
                    <button style={{ ...styles.button, ...styles.continue }} onClick={accept}>
                        I am {minAge}+ / Continue
                    </button>
                </div>

                <p style={styles.small}>
                    Note: We store a local flag in your browser (localStorage) so you won’t be asked again on this device.
                    If storing that flag is not possible, you will be redirected away.
                </p>
            </div>
        </div>
    );
}

const styles: Record<string, React.CSSProperties> = {
    backdrop: {
        position: "fixed",
        inset: 0,
        zIndex: 999999,
        background: "rgba(0,0,0,0.92)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 16,
    },
    card: {
        width: "min(680px, 100%)",
        background: "#111",
        border: "1px solid rgba(255,255,255,0.15)",
        borderRadius: 16,
        padding: 20,
        boxShadow: "0 20px 80px rgba(0,0,0,0.6)",
        color: "white",
    },
    title: {
        margin: "0 0 10px 0",
        fontSize: 28,
        lineHeight: 1.2,
    },
    p: {
        margin: "10px 0",
        fontSize: 16,
        lineHeight: 1.5,
        opacity: 0.95,
    },
    buttonRow: {
        display: "flex",
        gap: 10,
        marginTop: 16,
        flexWrap: "wrap",
    },
    button: {
        flex: "1 1 220px",
        padding: "12px 14px",
        borderRadius: 12,
        border: "1px solid rgba(255,255,255,0.18)",
        cursor: "pointer",
        fontSize: 16,
        fontWeight: 600,
    },
    leave: {
        background: "rgba(255,255,255,0.06)",
        color: "white",
    },
    continue: {
        background: "white",
        color: "black",
    },
    small: {
        marginTop: 14,
        fontSize: 12,
        lineHeight: 1.4,
        opacity: 0.75,
    },
};
